export const TOTAL_FAVOURITE_UNSEEN_COUNT = 'TOTAL_FAVOURITE_UNSEEN_COUNT';
export const TOTAL_LIKED_PRODUCT_SUCCESS = 'TOTAL_LIKED_PRODUCT_SUCCESS';
export const TOTAL_LIKED_MATERIAL_SUCCESS = 'TOTAL_LIKED_MATERIAL_SUCCESS';
export const TOTAL_LIKED_PRODUCT_FAILURE = 'TOTAL_LIKED_PRODUCT_FAILURE';
export const TOTAL_LIKED_MATERIAL_FAILURE = 'TOTAL_LIKED_MATERIAL_FAILURE';
export const FETCH_FAVOURITE_PRODUCT_LIST_SUCCESS = 'FETCH_FAVOURITE_PRODUCT_LIST_SUCCESS';
export const FETCH_FAVOURITE_PRODUCT_LIST_MORE_SUCCESS = 'FETCH_FAVOURITE_PRODUCT_LIST_MORE_SUCCESS';
export const FETCH_FAVOURITE_PRODUCT_LIST_FAILURE = 'FETCH_FAVOURITE_PRODUCT_LIST_FAILURE';

export const FETCH_FAVOURITE_MATERIAL_LIST_SUCCESS = 'FETCH_FAVOURITE_MATERIAL_LIST_SUCCESS';
export const FETCH_FAVOURITE_MATERIAL_LIST_MORE_SUCCESS = 'FETCH_FAVOURITE_MATERIAL_LIST_MORE_SUCCESS';
export const FETCH_FAVOURITE_MATERIAL_LIST_FAILURE = 'FETCH_FAVOURITE_MATERIAL_LIST_FAILURE';

export const FETCH_FAVOURITE_FOLDER_LIST_SUCCESS = 'FETCH_FAVOURITE_FOLDER_LIST_SUCCESS';
export const FETCH_FAVOURITE_FOLDER_LIST_MORE_SUCCESS = 'FETCH_FAVOURITE_FOLDER_LIST_MORE_SUCCESS';
export const FETCH_FAVOURITE_FOLDER_LIST_FAILURE = 'FETCH_FAVOURITE_FOLDER_LIST_FAILURE';
export const SET_ACTIVE_FAVOURITE_PAGE_TAB = 'SET_ACTIVE_FAVOURITE_PAGE_TAB';
